import { types } from '../reducers/canvasContentInfoReducer';

// eslint-disable-next-line import/prefer-default-export
export const createCanvasContentInfo = (values) => ({
  type: types.POST,
  payload: values,
});

export const updateCanvasContentInfo = (values) => ({
  type: types.PUT,
  payload: values,
});

export const removeCanvasContentInfo = (item) => ({
  type: types.DELETE,
  payload: item,
});

export const resetCanvasContentInfo = () => ({
  type: types.RESET,
});
